import { render, staticRenderFns } from "./BrandManagement.vue?vue&type=template&id=66d7e3ba"
import script from "./BrandManagement.vue?vue&type=script&lang=js"
export * from "./BrandManagement.vue?vue&type=script&lang=js"
import style0 from "./BrandManagement.vue?vue&type=style&index=0&id=66d7e3ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports